import React, { useEffect, useState, useRef } from 'react';
import { getToken } from '../api';

const WS_URL = 'wss://bot.nt55.ru/ws/livechat';
const STORAGE_KEY = 'maxbot_unread_chats';

interface Toast {
  id: number;
  chat_id: number;
  text: string;
}

// Загрузка из localStorage
const loadUnreadFromStorage = (): Set<number> => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) {
      const arr: number[] = JSON.parse(raw);
      return new Set(arr);
    }
  } catch (e) {}
  return new Set();
};

// Сохранение в localStorage
const saveUnreadToStorage = (chatIds: Set<number>) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(Array.from(chatIds)));
};

let globalAddToast: ((chat_id: number, text: string) => void) | null = null;
let globalAddUnread: ((chat_id: number) => void) | null = null;
let globalResetUnread: ((chat_id: number) => void) | null = null;

export const resetUnreadGlobal = (chatId: number) => {
  globalResetUnread?.(chatId);
};

const Notifications: React.FC = () => {
  const [unreadCount, setUnreadCount] = useState(0);
  const [toasts, setToasts] = useState<Toast[]>([]);
  // Инициализируем из localStorage
  const unreadChats = useRef<Set<number>>(loadUnreadFromStorage());
  const wsRef = useRef<WebSocket | null>(null);

  // При первом рендере синхронизируем state
  useEffect(() => {
    setUnreadCount(unreadChats.current.size);
  }, []);

  // Обновление заголовка вкладки
  useEffect(() => {
    const originalTitle = document.title;
    if (unreadCount > 0) {
      document.title = `🔴 (${unreadCount}) ${originalTitle}`;
    } else {
      document.title = originalTitle;
    }
    const handleVisibility = () => {
      if (document.visibilityState === 'visible' && unreadCount === 0) {
        document.title = originalTitle;
      }
    };
    document.addEventListener('visibilitychange', handleVisibility);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibility);
      document.title = originalTitle;
    };
  }, [unreadCount]);

  // WebSocket для получения событий
  useEffect(() => {
    const token = getToken();
    if (!token) return;
    const ws = new WebSocket(`${WS_URL}?token=${token}`);
    ws.onmessage = (event) => {
      let data;
      try {
        data = JSON.parse(event.data);
      } catch {
        return;
      }

      // Получаем накопленные счётчики при подключении
      if (data.type === 'init_unread') {
        const counts: Record<number, number> = data.unread_counts || {};
        const newSet = new Set<number>();
        Object.entries(counts).forEach(([chatId, count]) => {
          if (count > 0) newSet.add(Number(chatId));
        });
        unreadChats.current = newSet;
        saveUnreadToStorage(newSet);
        setUnreadCount(newSet.size);
      }
      // Новое сообщение во время работы
      else if (data.type === 'new_message') {
        globalAddToast?.(data.chat_id, data.text);
        globalAddUnread?.(data.chat_id);
      }
    };
    wsRef.current = ws;
    return () => ws.close();
  }, []);

  // Глобальные функции для использования из LiveChat
  globalAddToast = (chat_id, text) => {
    const id = Date.now();
    setToasts(prev => [...prev, { id, chat_id, text }]);
    setTimeout(() => setToasts(prev => prev.filter(t => t.id !== id)), 5000);
  };

  globalAddUnread = (chat_id) => {
    const prev = unreadChats.current;
    if (!prev.has(chat_id)) {
      const updated = new Set(prev);
      updated.add(chat_id);
      unreadChats.current = updated;
      saveUnreadToStorage(updated);
      setUnreadCount(updated.size);
    }
  };

  globalResetUnread = (chat_id) => {
    const prev = unreadChats.current;
    if (prev.has(chat_id)) {
      const updated = new Set(prev);
      updated.delete(chat_id);
      unreadChats.current = updated;
      saveUnreadToStorage(updated);
      setUnreadCount(updated.size);
    }
    if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
      wsRef.current.send(JSON.stringify({ action: 'read_chat', chat_id }));
    }
  };

  return (
    <>
      {toasts.map(t => (
        <div key={t.id} style={{
          position: 'fixed', top: 20, right: 20, background: '#1890ff',
          color: 'white', padding: '10px 20px', borderRadius: 6,
          zIndex: 9999, boxShadow: '0 2px 8px rgba(0,0,0,0.2)', maxWidth: 300
        }}>
          <div style={{ fontWeight: 'bold' }}>Новое сообщение от {t.chat_id}</div>
          <div style={{ fontSize: 13 }}>{t.text}</div>
        </div>
      ))}
      {unreadCount > 0 && (
        <span style={{
          position: 'fixed', top: 20, right: 20, background: 'red',
          color: 'white', borderRadius: '50%', width: 22, height: 22,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 12, zIndex: 10000
        }}>
          {unreadCount}
        </span>
      )}
    </>
  );
};

export default Notifications;